import { Pencil, Trash2, BookOpenCheck, FileText } from 'lucide-react';
import type { BuilderLesson } from '@/types';
import { LESSON_TYPE_ICONS, LESSON_TYPE_LABELS } from './lesson-types';

type LessonListItemProps = {
  lesson: BuilderLesson;
  isDraft: boolean;
  onEdit: (lesson: BuilderLesson) => void;
  onQuiz: (lesson: BuilderLesson) => void;
  onDelete: (lesson: BuilderLesson) => void;
};

export function LessonListItem({ lesson, isDraft, onEdit, onQuiz, onDelete }: LessonListItemProps) {
  const Icon = LESSON_TYPE_ICONS[lesson.lesson_type] ?? FileText;

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 pl-12 hover:bg-muted/20">
      <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
      <div className="flex-1">
        <span className="text-sm text-foreground">{lesson.title}</span>
        <span className="ml-2 text-xs text-muted-foreground">
          {LESSON_TYPE_LABELS[lesson.lesson_type]}
        </span>
      </div>
      {lesson.has_quiz && (
        <span className="rounded bg-purple-50 px-1.5 py-0.5 text-[10px] font-medium text-purple-700 ring-1 ring-purple-600/20 dark:bg-purple-900/30 dark:text-purple-400 dark:ring-purple-400/20">
          Quiz
        </span>
      )}
      {lesson.points > 0 && (
        <span className="text-xs text-muted-foreground">{lesson.points} pts</span>
      )}
      <div className="flex items-center gap-0.5">
        {isDraft && (
          <button
            onClick={() => onEdit(lesson)}
            className="rounded p-1 text-muted-foreground hover:bg-accent"
            aria-label="Editar lección"
            title="Editar lección"
          >
            <Pencil className="h-3.5 w-3.5" />
          </button>
        )}
        <button
          onClick={() => onQuiz(lesson)}
          className="rounded p-1 text-muted-foreground hover:bg-purple-50 hover:text-purple-700 dark:hover:bg-purple-900/30 dark:hover:text-purple-400"
          aria-label="Evaluación"
          title="Evaluación"
        >
          <BookOpenCheck className="h-3.5 w-3.5" />
        </button>
        {isDraft && (
          <button
            onClick={() => onDelete(lesson)}
            className="rounded p-1 text-muted-foreground hover:bg-destructive/10 hover:text-destructive"
            aria-label="Eliminar lección"
            title="Eliminar lección"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
